function preventDefault(e) {
    e.preventDefault();
}
function disableScroll() {
    window.addEventListener("scroll", preventDefault, { passive: false });
    window.addEventListener("wheel", preventDefault, { passive: false });
    window.addEventListener("touchmove", preventDefault, { passive: false });
}
export { disableScroll };
